import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

const PaymentDetails = (props) => (
  <Svg
    width={32}
    height={32}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <G clipPath="url(#a)" fill="#5FAFFF">
      <Path d="M25.973 25.027H5.493c-.733 0-1.333.6-1.333 1.333s.6 1.333 1.333 1.333H25.96c.733 0 1.333-.6 1.333-1.333s-.6-1.333-1.333-1.333h.013ZM5.72 13.56h2.64v7.64H6.893c-.733 0-1.333.6-1.333 1.333 0 .734.6 1.334 1.333 1.334H25.08c.733 0 1.333-.6 1.333-1.334 0-.733-.6-1.333-1.333-1.333h-1.307v-7.213c0-.147-.04-.294-.08-.427h2.4c1.387 0 1.96-1.56.854-2.293l-3.76-2.454-6.427-4.2a1.559 1.559 0 0 0-1.693 0l-6.427 4.2-3.76 2.454c-1.107.72-.533 2.293.853 2.293H5.72Zm15.48 0c-.04.133-.08.267-.08.427V21.2h-3.787v-7.64h3.88-.013Zm-6.547 0v7.64h-3.626v-7.64h3.626Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h32v32H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default PaymentDetails
